import {
  createColumnCenter,
  createColumnDate,
  createColumnText,
  createColumnPopover,
  widthOptions,
} from '@/components/table/function/createColumn';
import { Icon } from '@/resources';
import { color } from '../../../../resources';

export const columns = (onModalMessage = () => {}, onEdit = () => {}, onHistory = () => {}) => [
  createColumnText('รหัสลูกค้า', 'customerCode', widthOptions(150)),
  createColumnText('ชื่อ', 'fullName', widthOptions(130)),
  createColumnDate('วันเกิด', 'birthday', widthOptions(120)),
  createColumnCenter(
    'กลุ่มลูกค้า',
    'customerLevel',
    widthOptions(150, {
      render: (text, record) => {
        if (record.customerLevel === 'GENERAL') {
          return (
            <div style={{ color: color.search2 }}>
              <Icon.smile />
            </div>
          );
        } else if (record.customerLevel === 'MEMBER') {
          return (
            <div style={{ color: color.orangeTheme }}>
              <Icon.crown />
            </div>
          );
        }
        return null;
      },
    }),
  ),
  createColumnText('เบอร์ติดต่อ', 'telephone', widthOptions(150)),
  createColumnText('ไลน์', 'lineName', widthOptions(120)),
  createColumnPopover({
    title: 'จัดการ',
    dataIndex: 'rowNo',
    options: widthOptions(80, { fixed: 'right' }),
    contentOptions: {
      menuItems: [
        {
          icon: Icon.edit,
          text: 'แก้ไข',
          color: color.edit,
          onClick: (record) => onEdit(record),
        },
        {
          icon: Icon.history,
          text: 'ประวัติ',
          color: color.search2,
          onClick: (record) => onHistory(record),
        },
        {
          icon: Icon.message,
          text: 'ส่งข้อความ',
          color: color.line,
          onClick: (record) => onModalMessage(record),
        },
      ],
    },
  }),
];
